import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const main: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.tabs.main') as string;
			},
			trappRoute(to: Route): string {
				return `/fhcgbd.shtml?hcgd=${to.params.groupId}`;
			},
		},
		path: '',
		name: Routes.GROUP_MAIN,
		component: () => import(/* webpackChunkName: "group_main" */ '@front-app/views/home/group/GroupMain.vue'),
	},
];
